module.exports = __webpack_public_path__ + "static/media/map.0c2f9826.png";